import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MedicalSquare = function MedicalSquare(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 7.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C5.2798 3 6.1198 3 7.8 3h8.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.2798 21 6.1198 21 7.8v8.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C18.7202 21 17.8802 21 16.2 21H7.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.7202 3 17.8802 3 16.2z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.8333 7.3c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185c-.1069-.0545-.2469-.0545-.527-.0545h-2.0666c-.2801 0-.4201 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.107-.0545.247-.0545.527v2.0667c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185c-.107.0545-.247.0545-.527.0545H7.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185c-.0545.1069-.0545.2469-.0545.527v2.0666c0 .2801 0 .4201.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545h2.0667c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185c.0545.107.0545.247.0545.527V16.7c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.1069.0545.2469.0545.527.0545h2.0666c.2801 0 .4201 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.0667c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185c.107-.0545.247-.0545.527-.0545H16.7c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.1069.0545-.2469.0545-.527v-2.0666c0-.2801 0-.4201-.0545-.527a.5.5 0 0 0-.2185-.2185c-.107-.0545-.247-.0545-.527-.0545h-2.0667c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185c-.0545-.107-.0545-.247-.0545-.527z"
    })]
  }));
};
export default MedicalSquare;